module.exports = __webpack_public_path__ + "img/auto-uploaded-to-aconex.0957ac7c.png";